import { Minus, Plus } from "lucide-react";

export const QtyControl = ({ value, onChange, testId = "qty", size = "md" }) => {
  const h = size === "sm" ? "h-8" : "h-10";
  return (
    <div className={`inline-flex ${h} items-center rounded-full border border-border bg-card`} data-testid={`${testId}-control`}>
      <button
        type="button"
        aria-label="Azalt"
        data-testid={`${testId}-decrease`}
        onClick={() => onChange(value - 1)}
        className={`btn-press flex ${h} w-9 items-center justify-center rounded-l-full hover:bg-muted`}
      >
        <Minus className="h-3.5 w-3.5" />
      </button>
      <span data-testid={`${testId}-value`} className="min-w-[2rem] text-center text-sm font-medium tabular-nums">
        {value}
      </span>
      <button
        type="button"
        aria-label="Artır"
        data-testid={`${testId}-increase`}
        onClick={() => onChange(value + 1)}
        className={`btn-press flex ${h} w-9 items-center justify-center rounded-r-full hover:bg-muted`}
      >
        <Plus className="h-3.5 w-3.5" />
      </button>
    </div>
  );
};
